import React from 'react'

export default class PromiseRenderer extends React.Component {
	state = {
		node: null
	}

	componentDidMount() {
		this.hasNewPromise()
	}

	componentDidUpdate(prevProps) {
		if (this.props.promise !== prevProps.promise) {
			this.hasNewPromise()
		}
	}

	hasNewPromise() {
		const newPromise = this.props.promise
		this.setState({ node: null })
		newPromise.then(node => {
			this.setState(() => {
				if (this.props.promise === newPromise) {
					return { node }
				}
			})
		})
	}

	render() {
		return this.props.children(this.state.node) || null
	}
}



// WEBPACK FOOTER //
// ./src/PromiseRenderer.js